/*
  Fluffberry "Ways to Wear" video tiles.

  A tile with a video URL renders a play button; activating it swaps the
  still image for an inline YouTube/Vimeo embed. Follows Dawn's
  custom-elements pattern; no dependencies.
*/
class WaysToWearTile extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.fluffberry-ways__play');
    if (this.button) {
      this.button.addEventListener('click', this.loadVideo.bind(this));
    }
  }

  loadVideo() {
    const embedUrl = this.dataset.videoEmbed;
    if (!embedUrl || this.querySelector('iframe')) return;

    const iframe = document.createElement('iframe');
    iframe.src = embedUrl;
    iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
    iframe.setAttribute('allowfullscreen', 'true');
    iframe.setAttribute('title', this.dataset.videoTitle || '');

    const media = this.querySelector('.fluffberry-ways__media');
    media.appendChild(iframe);
    this.button.remove();
    this.button = null;
  }
}

if (!customElements.get('ways-to-wear-tile')) {
  customElements.define('ways-to-wear-tile', WaysToWearTile);
}
